import React from "react";
import { ParameterFilterOption } from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import styles from "./parameter_title_button.module.sass";

type ParameterTitleButtonProps = {
  parameter: ParameterFilterOption;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
  onShowHint: (description: string) => void;
};

export const ParameterTitleButton = ({
  isExpanded,
  parameter,
  toggleIsExpanded,
  onShowHint,
}: ParameterTitleButtonProps): JSX.Element => {
  const fetchDescription = () => {
    if (parameter.hintPath) {
      fetch(parameter.hintPath)
        .then((response) => response.text())
        .then((data) => onShowHint(data))
        .catch(() => {
          onShowHint("Při načítání nastala chyba");
        });
    } else {
      onShowHint("Položku se nepodařilo načíst");
    }
  };

  return (
    <div className={styles.paramTitle}>
      <button
        onClick={toggleIsExpanded}
        className={[
          isExpanded ? styles.expanded : styles.collapsed,
          styles.title,
        ].join(" ")}
      >
        {parameter.name}
      </button>
      {parameter.hintPath && (
        <button className={styles.paramHint} onClick={fetchDescription}>
          ?
        </button>
      )}
    </div>
  );
};
